import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { CTA } from "../../../general/Button";
import TinyModal from "../../../general/TinyModal";

type HelpModalProps = {
    show: boolean;
    onHide: () => void;
    siteTel: string;
    provider: string;
    providerTel: string;
    providerLink: string;
};

const HelpModal = ({
    show,
    onHide,
    siteTel,
    provider,
    providerTel,
    providerLink
}: HelpModalProps) => {

    useEffect(() => {
        document.getElementById('help-modal')?.classList.add('anim-enter');

        return () => {
            document.getElementById('help-modal')?.classList.remove('anim-enter');
        };
    }, [show]);

    const renderFooter = () => (
        <>
            <CTA block
                 onClick={onHide}>
                <span>OK</span>
            </CTA>
        </>
    );

    return (
        <TinyModal
            show={show}
            onHide={onHide}
            backdropClassName="modal-order-support-backdrop"
            className="order-support-modal-dialog"
            header="Order support"
            footer={renderFooter()}
            modalID={'help-modal'}
        >
           <>
               <p>Need help with your order?</p>
               <p>Please contact our team at <a href={'tel:' + siteTel.replaceAll(' ', '')}>{siteTel}</a>.</p>
           </>
        </TinyModal>
    );
};

export default HelpModal;
